module.exports = __webpack_public_path__ + "img/4.8580dd54.png";